import { themeAtom } from "../atoms";
import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { useLocation } from "react-router";
import { twMerge } from "tailwind-merge";

// Cookie consent must be displayed in a visible location.
// All public facing pages must include this footer.
interface PageFooterProps {
  className?: string;
}

const PageFooter: React.FC<PageFooterProps> = ({ className }) => {
  const location = useLocation();
  const theme = useAtomValue(themeAtom);

  // Re-run the script on every route change
  useEffect(() => {
    loadTrustArcScript();
  }, [location.pathname]);

  return (
    <div
      className={twMerge(
        "ml-4 flex flex-row p-2 pb-3 text-sm",
        className,
        theme.home.tailwind.pageBackground,
        theme.myVesselsTable.tailwind.textDefault,
      )}
    >
      <span className="pr-2" id="teconsent" />
      <span className="pr-2" id="trustarc-irm-placeholder" />
      <span className="pr-2" id="consent_blackbar" />
    </div>
  );
};

export default PageFooter;

// We need to reload the script on each navigation event to generate the "Manage Cookies" link.
// If we use only the index.html script then the first page shows the link and all other pages no longer show it.
const loadTrustArcScript = () => {
  const existingScript = document.getElementById("trustarc-consent-script");
  if (existingScript) {
    existingScript.remove();
  }

  const script = document.createElement("script");
  script.src =
    "//consent.trustarc.com/notice?domain=cargill_opslink.cglcloud.com&c=teconsent&js=nj&noticeType=bb&gtm=1&text=true&irmc=trustarc-irm-placeholder";
  script.type = "text/javascript";
  script.async = true;
  script.id = "trustarc-consent-script";
  document.head.appendChild(script);
};
